import * as TypeGraphQL from "type-graphql";
export var ConnectionHealthSnapshotScalarFieldEnum;
(function (ConnectionHealthSnapshotScalarFieldEnum) {
    ConnectionHealthSnapshotScalarFieldEnum["id"] = "id";
    ConnectionHealthSnapshotScalarFieldEnum["timestamp"] = "timestamp";
    ConnectionHealthSnapshotScalarFieldEnum["connectionType"] = "connectionType";
    ConnectionHealthSnapshotScalarFieldEnum["endpoint"] = "endpoint";
    ConnectionHealthSnapshotScalarFieldEnum["status"] = "status";
    ConnectionHealthSnapshotScalarFieldEnum["metrics"] = "metrics";
    ConnectionHealthSnapshotScalarFieldEnum["metadata"] = "metadata";
    ConnectionHealthSnapshotScalarFieldEnum["createdAt"] = "createdAt";
})(ConnectionHealthSnapshotScalarFieldEnum || (ConnectionHealthSnapshotScalarFieldEnum = {}));
TypeGraphQL.registerEnumType(ConnectionHealthSnapshotScalarFieldEnum, {
    name: "ConnectionHealthSnapshotScalarFieldEnum",
    description: undefined,
});
//# sourceMappingURL=ConnectionHealthSnapshotScalarFieldEnum.js.map